import { API_BASE_URL } from '../config/api';

export interface ClientRequest {
  id: string;
  clientId: string;
  clientName: string;
  clientEmail: string;
  dietitianId: string;
  message?: string;
  status: 'Pending' | 'Accepted' | 'Rejected';
  createdAt: string;
  respondedAt?: string;
}

export interface CreateClientRequestRequest {
  clientId: string;
  dietitianId: string;
  message?: string;
}

export interface AcceptClientRequestRequest {
  message?: string;
}

export interface RejectClientRequestRequest {
  message?: string;
}

export const clientRequestApi = {
  async createClientRequest(
    request: CreateClientRequestRequest
  ): Promise<ClientRequest> {
    const response = await fetch(`${API_BASE_URL}/clientrequests`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(request),
    });
    if (!response.ok) {
      const error = await response.json();
      throw new Error(error.message || 'İstek gönderilemedi');
    }
    return await response.json();
  },

  async getClientRequestsByDietitian(
    dietitianId: string
  ): Promise<ClientRequest[]> {
    const response = await fetch(
      `${API_BASE_URL}/clientrequests/dietitian/${dietitianId}`
    );
    if (!response.ok) {
      throw new Error('İstekler getirilemedi');
    }
    return await response.json();
  },

  async getClientRequestsByClient(clientId: string): Promise<ClientRequest[]> {
    const response = await fetch(
      `${API_BASE_URL}/clientrequests/client/${clientId}`
    );
    if (!response.ok) {
      throw new Error('İstekler getirilemedi');
    }
    return await response.json();
  },

  async getClientRequestById(id: string): Promise<ClientRequest> {
    const response = await fetch(`${API_BASE_URL}/clientrequests/${id}`);
    if (!response.ok) {
      throw new Error('İstek bulunamadı');
    }
    return await response.json();
  },

  async acceptClientRequest(
    id: string,
    request: AcceptClientRequestRequest
  ): Promise<ClientRequest> {
    const response = await fetch(`${API_BASE_URL}/clientrequests/${id}/accept`, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(request),
    });
    if (!response.ok) {
      const error = await response.json();
      throw new Error(error.message || 'İstek kabul edilemedi');
    }
    return await response.json();
  },

  async rejectClientRequest(
    id: string,
    request: RejectClientRequestRequest
  ): Promise<ClientRequest> {
    const response = await fetch(`${API_BASE_URL}/clientrequests/${id}/reject`, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(request),
    });
    if (!response.ok) {
      const error = await response.json();
      throw new Error(error.message || 'İstek reddedilemedi');
    }
    return await response.json();
  },

  async deleteClientRequest(id: string): Promise<void> {
    const response = await fetch(`${API_BASE_URL}/clientrequests/${id}`, {
      method: 'DELETE',
    });
    if (!response.ok) {
      throw new Error('İstek silinemedi');
    }
  },
};

